import React, {useEffect, useState} from 'react';
import './Profile.css';
import Header from './Header';
import Cover from './Cover';
import Post from './Post';
import PostHeader from './PostHeader';
import db from './firebase';

function Profile() {
    var link = window.location.href
    var linkd = link.split('/')
    console.log(linkd[4])
    const [frilist, setFrilist] = useState([])
    useEffect(() => {
        db.collection('users').where('email','==',linkd[4]).onSnapshot(
            snapshot => setFrilist(snapshot.docs.map((doc)=>
            ({id:doc.id, data:doc.data()})))
        )
    }, [])
    const [about, setAbout] = useState(true)
    const button = () => {
        setAbout(!about)
    }
    return (
        <div className="profile">
            {
                frilist.map((fri)=>(
                <>
                    <Cover 
                    coverPic = {fri.data.coverImage}
                    profilePic = {fri.data.profileImage}
                    username = {fri.data.name}
                    email = {fri.data.email}
                    />
                    <PostHeader 
                    profilePic={fri.data.profileImage}
                    username = {fri.data.name}
                    userId = {fri.id}
                    button = {button}
                    about = {about}
                    />
                    <Post 
                    profilePic={fri.data.profileImage}
                    username = {fri.data.name}
                    userId = {fri.id}
                    about = {about}
                    />
                </>
                ))
            }
            
        </div>
    )
}

export default Profile
